import { render, staticRenderFns } from "./BenefitsOfRegistration.vue?vue&type=template&id=655c8bbd&scoped=true&"
import script from "./BenefitsOfRegistration.vue?vue&type=script&lang=ts&setup=true&"
export * from "./BenefitsOfRegistration.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./BenefitsOfRegistration.vue?vue&type=style&index=0&id=655c8bbd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "655c8bbd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('655c8bbd')) {
      api.createRecord('655c8bbd', component.options)
    } else {
      api.reload('655c8bbd', component.options)
    }
    module.hot.accept("./BenefitsOfRegistration.vue?vue&type=template&id=655c8bbd&scoped=true&", function () {
      api.rerender('655c8bbd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/profile/lpus/register/index/LpusRegisterContent/components/BenefitsOfRegistration.vue"
export default component.exports